<div
  *ngIf="model"
  class="pagination-container d-flex justify-content-between align-items-center"
  [ngClass]="getPaginationContainerClass()"
>
  <div class="show-per-page-container col">
    <ng-container
      *ngIf="model.settings.recordCount >= 11 && showItemsPerPage()"
    >
      <label for="show-items-select">Show Items per Page: </label>
      <select
        name="show-items-select"
        (ngModel)="(model.settings.pageSize)"
        (ngModelChange)="changeShowItemsPerPage($event)"
      >
        <option value="10" [selected]="model.settings.pageSize === 10">
          10
        </option>
        <option value="20" [selected]="model.settings.pageSize === 20">
          20
        </option>
        <option value="50" [selected]="model.settings.pageSize === 50">
          50
        </option>
        <option value="100" [selected]="model.settings.pageSize === 100">
          100
        </option>
      </select>
    </ng-container>
  </div>

  <ng-container *ngIf="model.settings.recordCount >= model.settings.pageSize">
    <pagination
      [totalItems]="model.settings.recordCount"
      [(ngModel)]="model.settings.currentPage"
      (pageChanged)="pageChanged($event)"
      [maxSize]="7"
      [itemsPerPage]="model.settings.pageSize"
      [boundaryLinks]="true"
      class="col-auto justify-content-center"
      [customFirstTemplate]="firstTemplate"
      [customLastTemplate]="lastTemplate"
      [customPreviousTemplate]="prevTemplate"
      [customNextTemplate]="nextTemplate"
    ></pagination>
    <ng-template
      #lastTemplate
      let-disabled="disabled"
      let-currentPage="currentPage"
    >
      <span class="narrow-icons"
        ><span class="oi oi-caret-right"></span
        ><span class="oi oi-caret-right"></span
      ></span>
    </ng-template>

    <ng-template
      #firstTemplate
      let-disabled="disabled"
      let-currentPage="currentPage"
    >
      <span class="narrow-icons"
        ><span class="oi oi-caret-left"></span
        ><span class="oi oi-caret-left"></span
      ></span>
    </ng-template>
    <ng-template
      #nextTemplate
      let-disabled="disabled"
      let-currentPage="currentPage"
    >
      <span class="oi oi-caret-right"></span>
    </ng-template>

    <ng-template
      #prevTemplate
      let-disabled="disabled"
      let-currentPage="currentPage"
    >
      <span class="oi oi-caret-left"></span>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="model.settings.recordCount < model.settings.pageSize">
    <div class="col"></div>
  </ng-container>
  <div class="right col text-right">
    <ng-container *ngIf="showItemsPerPage()">
      <label *ngIf="showRecordsCount()" class="filter-btn-count">
        {{ getRecordsCount() }}
      </label>
    </ng-container>
  </div>
</div>
